module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "title"
  }, [_vm._v("AGENDA\n    "), _c('button', {
    staticClass: "close text-white",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$modal.hide('modalAgenda')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('table', {
    staticClass: "table table-sm table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.schedules), function(c) {
    return _c('tr', {
      key: c.id,
      on: {
        "dblclick": function($event) {
          return _vm.editSchedule(c)
        }
      }
    }, [_c('td', {
      staticClass: "align-middle"
    }, [_vm._v(_vm._s(_vm._f("firstAndLastName")(c.contato)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center align-middle"
    }, [_vm._v(_vm._s(_vm._f("dateISOFormat")(c.data)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center align-middle"
    }, [_vm._v(_vm._s(c.hora))]), _vm._v(" "), _c('td', {
      staticClass: "align-middle",
      staticStyle: {}
    }, [_c('pre', [_vm._v(_vm._s(c.obs))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center align-middle"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-outline-info",
      on: {
        "click": function($event) {
          return _vm.editSchedule(c)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "w-25"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Hora")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Observação")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-783dae32","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Schedule/ScheduleList.vue
// module id = 749
// module chunks = 7